'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactI18next = require('react-i18next');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TermsHint = (_dec = (0, _reactI18next.translate)(['common']), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(TermsHint, _Component);

  function TermsHint() {
    (0, _classCallCheck3.default)(this, TermsHint);
    return (0, _possibleConstructorReturn3.default)(this, (TermsHint.__proto__ || (0, _getPrototypeOf2.default)(TermsHint)).apply(this, arguments));
  }

  (0, _createClass3.default)(TermsHint, [{
    key: 'render',


    /* eslint-disable max-len */
    value: function render() {
      var _props = this.props,
          t = _props.t,
          className = _props.className,
          nonStyled = _props.nonStyled;


      return _react2.default.createElement(
        'div',
        { className: (0, _classnames2.default)({ 'text-center margin-top-10 colorDark': !nonStyled }, className) },
        t('Cright is processing the User Files and your Personal Data and providing the Service on behalf of a third party and in accordance with the third party’s instructions and control.')
      );
    }
    /* eslint-enable max-len */

  }]);
  return TermsHint;
}(_react.Component), _class2.propTypes = {
  className: _propTypes2.default.string,
  nonStyled: _propTypes2.default.bool,
  t: _propTypes2.default.func
}, _temp)) || _class);
exports.default = TermsHint;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Auth/TermsHint.js
// module id = 512
// module chunks = 1